import * as customersActions from './customersActions';
import customersReducer from './customersReducer';
import customersSagas from './customersSagas';
import * as customersSelectors from './customersSelectors';
import * as customersTransformers from './customersTransformers';
import * as customersTypes from './customersTypes';

const { CUSTOMERS_REDUCER_KEY } = customersTypes;
const CUSTOMERS_VERSION_NUMBER = 3;

export {
  CUSTOMERS_REDUCER_KEY,
  CUSTOMERS_VERSION_NUMBER,
  customersActions,
  customersReducer,
  customersSagas,
  customersSelectors,
  customersTransformers,
  customersTypes,
};
